import Image from '@react/shared/components/Image';
import { Arrow } from 'sly/icons';
import { cx } from 'sly/lib/clsxm';
import { Link } from 'sly/system';

import MarketingPageTitle from '../MarketingPageTitle';
import { GetListWithImg } from '../../HubPage/HubPage.types';
import MarketingPageWrapper from '../../MarketingPageWrapper';

const AvatarListWithImage = ({
  getListWithImg,
}: {
  getListWithImg: GetListWithImg;
}) => {
  return (
    <MarketingPageWrapper>
      <MarketingPageTitle title={getListWithImg?.heading} />
      <div
        className='flex w-full flex-col lg:w-[42.5rem] lg:items-baseline'
        data-tp-id='gen-Flex-cba6bef0-5ab9-49a8-a5ea-d5ae44118022'
      >
        <div
          className={cx(
            'mb-xxl flex flex-wrap',
            'justify-center gap-m md:gap-l'
          )}
          data-tp-id='gen-div-0434469e-64c8-48aa-9a23-9c8bef555923'
        >
          {getListWithImg?.imgWithTitle?.length > 0 &&
            getListWithImg?.imgWithTitle?.map((item, index) => {
              const path = item?.srcImg?.path;
              return (
                <div
                  className={cx(
                    ' mb-xs flex flex-col text-center',
                    'basis-[9.75rem] md:basis-[9.5rem]'
                  )}
                  key={item.id}
                  data-tp-id='gen-Flex-c066032f-c96d-48cf-bf5b-a9a8068c943a'
                >
                  {path ? (
                    <div
                      className='relative mb-m aspect-1'
                      data-tp-id='gen-div-38cae7e8-15fc-4c8a-8b43-b7519c4b2a24'
                    >
                      <Image
                        className={cx('rounded-[50%]')}
                        objectFit='cover'
                        path={path}
                        priority={index === 0}
                        loading='eager'
                        alt={item.title}
                        data-tp-id='gen-Image-fe729e63-97d5-4130-8af1-90e14183301b'
                      />
                    </div>
                  ) : (
                    <div
                      className={cx(
                        'rounded-[50%] bg-slate-lighter-90',
                        'h-[9.75rem]',
                        'md:h-[9.5rem]',
                        'mb-s'
                      )}
                      data-tp-id='gen-Block-a5d8f280-e8fb-488b-8b23-7f8892805b67'
                    />
                  )}
                  <p
                    className='font-b-l mb-xxs'
                    data-tp-id='gen-Paragraph-8d01835f-63fe-43ac-8e38-7ff173c455d3'
                  >
                    {item.title}
                  </p>
                  <p
                    className='font-b-s text-slate-lighter-40'
                    data-tp-id='gen-Paragraph-ca6e45ca-d3fe-4caf-a8c8-b87649a31dbb'
                  >
                    {item.subTitle}
                  </p>
                </div>
              );
            })}
        </div>
        <p
          className='font-b-l mb-l w-auto'
          data-tp-id='gen-Paragraph-e87157c8-32c0-4128-a07a-74516b6db3dd'
        >
          {getListWithImg?.decription}
        </p>
        {getListWithImg?.to && getListWithImg?.textLink && (
          <Link
            to={getListWithImg?.to}
            className='font-t-s-azo no-underline'
            data-tp-id='gen-Link-44c70df3-0cf1-4f0d-816c-46800939ef14'
          >
            {getListWithImg?.textLink}
            <Arrow className='rotate-90' />
          </Link>
        )}
      </div>
    </MarketingPageWrapper>
  );
};

export default AvatarListWithImage;
